import { keepPreviousData, useQuery } from '@tanstack/react-query';
import api from '@/libs/axiosInstance';
import type { PayableAffiliateCommission } from '@/types/commission';
import type { CommissionRewardReviewSummary } from '@fluenceur/types';

interface PendingCommissionsFilters {
  affiliateIds?: string[];
}

interface PendingCommissionCreatorResponse {
  commissions: PayableAffiliateCommission[];
  rewardReviews?: CommissionRewardReviewSummary[];
}

const fetchPendingCommissions = async (
  filters?: PendingCommissionsFilters
): Promise<PendingCommissionCreatorResponse> => {
  const params: Record<string, string | string[]> = {};
  if (filters?.affiliateIds && filters.affiliateIds.length > 0) {
    // Send as array, not comma-separated string
    params.affiliateIds = filters.affiliateIds;
  }

  const { data } = await api.get<PendingCommissionCreatorResponse>(
    '/dashboard/affiliates/commissions/pending',
    {
      params: params,
    }
  );
  return data;
};

export const usePendingCommissionsQuery = (filters?: PendingCommissionsFilters) => {
  return useQuery<PendingCommissionCreatorResponse, Error>({
    queryKey: ['commissions', 'pendingByAffiliate', filters],
    queryFn: () => fetchPendingCommissions(filters),
    placeholderData: keepPreviousData,
  });
};
